<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-operations">
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>

      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :pagination="false" :bordered="tableBordered">
        <span slot="operation" slot-scope="text, record">
          <a @click="showDetail(record)">
            <a-icon type="eye" />查看更多
          </a>
        </span>
      </a-table>

      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
// 仅保留分页查询接口
import { codeEmailPage } from '@/api/privilegeCode/privilegeCode'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserPrize',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      // 查询参数仅保留分页相关
      queryParam: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [

        {
          title: '用户ID',
          dataIndex: 'id',
          width: '120',
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: '120',
          align: 'center'
        },
        {
          title: '提交发放兑换码的邮箱',
          dataIndex: 'privilegeCodeEmail',
          width: '120',
          align: 'center'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          width: '120',
          align: 'center',
          customRender: function (text) {
            if (text) {
              return text
            } else {
              return '-'
            }
          }
        },
        {
          title: '是否会员',
          dataIndex: 'isVip',
          width: '120',
          align: 'center',
          customRender: function (t, r, index) {
            if (t == 0) {
              return '否'
            } else if (t == 1) {
              return '是'
            }
          }
        },
        {
          title: '会员过期时间',
          dataIndex: 'vipOverTime',
          scopedSlots: { customRender: 'vipOverTime' },
          width: '120',
          align: 'center'
        },
        {
          title: '最后登录时间',
          dataIndex: 'lastLogin',
          scopedSlots: { customRender: 'lastLogin' },
          width: '120',
          align: 'center'
        },
        {
          title: '订阅状态',
          dataIndex: 'subscribeStatus',
          width: '120',
          align: 'center',
          customRender: function (subscribeStatus) {
            const activeStatusList = [0, 1, 3, 7, 8, 9, 11, 12, 13];
            const noActiveStatusList = [2, 4, 6, 10, 14];
            if (activeStatusList.includes(subscribeStatus)) {
              return "订阅中";
            } else if (noActiveStatusList.includes(subscribeStatus)) {
              return "取消订阅";
            } else {
              return "暂无订阅状态";
            }
          }
        },
        {
          title: '用户类型',
          dataIndex: 'isGuest',
          width: '120',
          align: 'center',
          customRender: function (t, r, index) {
            if (t == 1) {
              return '注册用户'
            } else if (t == 2) {
              return '游客'
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          align: 'center',
          scopedSlots: { customRender: 'operation' } // 必须对应 template 中的 slot="operation"
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    showDetail (record) {
    this.$info({
      title: '用户详细信息',
      width: 600,
      maskClosable: true, // 点击遮罩层可关闭
      content: (
        <div style="margin-top: 20px;">
          <a-descriptions bordered column={1} size="small">
            <a-descriptions-item label="用户ID">{ record.ip }</a-descriptions-item>
            <a-descriptions-item label="用户昵称">{ record.address || '-' }</a-descriptions-item>
            <a-descriptions-item label="原始邮箱">{ record.platform || '-' }</a-descriptions-item>
            <a-descriptions-item label="注册时间">{ record.createTime }</a-descriptions-item>
          </a-descriptions>
        </div>
      ),
      onOk() {},
    });
  },
    /** 查询列表 */
    getList() {
      this.loading = true
      codeEmailPage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 分页回调 */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>